export { FooterColumnSkeleton } from './FooterColumnSkeleton';
